<template>
<v-flex>
  <v-flex >
      <!-- v-show instead of v-if because of errant transition on v-menu label -->
      <v-menu v-show="active===3 || active === '3'"
        ref="menu2"
        lazy
        :close-on-content-click="false"
        v-model="menu2"
        transition="scale-transition"
        full-width 
        mx-auto
        min-width="290px"
        :return-value.sync="date"
        class="mx-2"
      >
        <v-text-field
          slot="activator"
          label="Select Date"
          v-model="date"
          prepend-icon="event"
          readonly
        ></v-text-field>
        <v-date-picker v-model="date" @input="$refs.menu2.save(date); logDate();"></v-date-picker>
      </v-menu>
      <v-flex v-show="active!==3 && active !== '3'" class="mx-2">
        <v-select
          label="Select Date Range"
          prepend-icon="event"
          @input="logDate();"
          :items="[
            { text: 'All', value: 3600  },
            { text: 'Last 7 Days', value: 7 },
            { text: 'Last 15 Days', value: 15 },
            { text: 'Last 30 Days', value: 30 },
            { text: 'Last 60 Days', value: 60 },
            { text: 'Last 90 Days', value: 90 },
            { text: 'Last 180 Days', value: 180 },
            { text: 'Last 360 Days', value: 360 }
          ]"
          v-model="daysAgo"
        ></v-select>
      </v-flex>
    </v-flex>

<v-tabs
  v-model="active"
  color="primary"
  dark
  slider-color="primary darken-2" class='my-4'
  show-arrows
  v-if="true"
>
      <v-tab key="a" ripple>Voice Function</v-tab>
      <v-tab-item key="a" >
        <v-toolbar flat class="" > <v-toolbar-title>Voice Function</v-toolbar-title></v-toolbar>
        <v-card dark color="white" class="mb-5 py-4 px-2" flat>
          <line-chart
            :data="chartDataVoiceFeeling"
            :messages="{ empty: 'No data' }"
            legend="bottom"
            :curve="false"
            :max="4"
            :library="{
              yAxis: { categories: voiceFeelDefaults.map(feel=>feel.text) },
              tooltip: {
                xDateFormat:'%A, %b %e, %Y',
                pointFormatter: function () { return `${this.series.name}: <b>${this.series.chart.yAxis[0].categories[this.y]}</b><br/>` }
              }
            }"
          ></line-chart> 
        </v-card> 
      </v-tab-item>
      <v-tab key="b" ripple>Units Budgeted vs Used</v-tab>
      <v-tab-item key="b" >
        <v-toolbar flat class="" > <v-toolbar-title>Units Budgeted vs Used</v-toolbar-title></v-toolbar>
        <v-card dark color="white" class="mb-5 py-4 px-2" flat>
          <line-chart :data="chartDataUnitsVsVoiceFeeling" :messages="{empty: 'No data'}" legend="bottom" :curve="false" :library="{tooltip: {xDateFormat:'%A, %b %e, %Y'}}"></line-chart> 
        </v-card> 
      </v-tab-item>
      <v-tab key="c" ripple>Ceiling Pitch</v-tab>
      <v-tab-item key="c" >
        <v-toolbar flat class="" > <v-toolbar-title>Ceiling Pitch</v-toolbar-title></v-toolbar>
        <v-card dark color="white" class="mb-5 py-4 px-2" flat>
          <line-chart
            :data="chartDataPitch"
            :messages="{ empty: 'No data' }"
            legend="bottom"
            :curve="false"
            :min="midiC2" :max="midiC7"
            :library="{
              yAxis: {
                categories: (Array.from({ length: 120 })).map((n, i) => noteNumberToName(i)),
                tickInterval: 12
              },
              tooltip: {
                xDateFormat:'%A, %b %e, %Y',
                pointFormatter: function () { return `${this.series.name}: <b>${this.series.chart.yAxis[0].categories[this.y]}</b><br/>` }
              }
            }"
          ></line-chart> 
        </v-card> 
      </v-tab-item>
      <v-tab key="d" ripple>Daily Activity</v-tab>
      <v-tab-item key="d" >
        <v-toolbar flat class="" > <v-toolbar-title>Daily {{appTitle}} Activity</v-toolbar-title></v-toolbar>
        <v-card dark color="white" class=" pa-4" flat>
          <column-chart :data="chartData" :messages="{empty: 'No data'}" legend="bottom"  :library="{tooltip: {xDateFormat:'%A, %b %e, %Y'}}"></column-chart>
          <v-card-text class="black--text  mt-4 text-xs-center">This chart only includes data for the selected date: {{date}}.</v-card-text>
        </v-card> 
        <v-data-table flat class="mt-0" 
        :headers="headers"
        :items="items2"  v-model="items2" hide-actions :pagination.sync="pagination" @load="onUpdate(items2, function(data){ items2=data;});"  >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td >{{ props.item.activityType }}<div class="caption mt-1">{{ props.item.notes}}</div></td>
          <td v-if="false" class="">{{ props.item.intensity}}</td>
          <td class="">{{ props.item.value }}</td>
        </template>
      </v-data-table> 
      </v-tab-item>
      <v-tab key="e" ripple>All Activity</v-tab>
      <v-tab-item key="e" >
        <v-toolbar flat class="" > <v-toolbar-title>All {{appTitle}} Activity</v-toolbar-title></v-toolbar>
        <v-card dark color="white" class="mb-5 py-4 px-2" flat>
          <line-chart  :data="chartData2" 
          :messages="{empty: 'No data'}" 
          legend="bottom" 
          :curve="false"  
          id="allActivitiesChart" 
          :chart-id="allActivitiesChart"
          :library="{tooltip: {xDateFormat:'%A, %b %e, %Y'}}"
          ></line-chart> 
          <v-card-text class="black--text  mt-4 text-xs-center">This chart includes all activities logged in {{appTitle}}</v-card-text>
        </v-card> 
      </v-tab-item>
      <v-tab key="f" ripple>Water Consumption</v-tab>
      <v-tab-item key="f" >
        <v-toolbar flat class="" > <v-toolbar-title>Water Consumption</v-toolbar-title></v-toolbar>
        <v-card dark color="white" class="mb-5 py-4 px-2" flat>
          <line-chart :data="chartDataWater" :messages="{empty: 'No data'}" legend="bottom" :curve="false" :library="{tooltip: {xDateFormat:'%A, %b %e, %Y'}}"></line-chart> 
        </v-card> 
      </v-tab-item>
      <v-tab key="g" ripple>Vocal Naps</v-tab>
      <v-tab-item key="g" >
        <v-toolbar flat class="" > <v-toolbar-title>Vocal Naps</v-toolbar-title></v-toolbar>
        <v-card dark color="white" class="mb-5 py-4 px-2" flat>
          <line-chart :data="chartDataNaps" :messages="{empty: 'No data'}" legend="bottom" :curve="false" :library="{tooltip: {xDateFormat:'%A, %b %e, %Y'}}"></line-chart> 
        </v-card> 
      </v-tab-item> 
      <v-tab key="h" ripple>Sick Days</v-tab>
      <v-tab-item key="h" >
        <v-toolbar flat class="" > <v-toolbar-title>Sick Days</v-toolbar-title></v-toolbar>
        <v-card dark color="white" class="mb-5 py-4 px-2" flat>
          <line-chart :data="chartDataSick" :messages="{empty: 'No data'}" legend="bottom" :curve="false" :plotOptions="hpOpts" :library="{tooltip: {xDateFormat:'%A, %b %e, %Y'}}"></line-chart> 
        </v-card> 
      </v-tab-item> 
</v-tabs>  





  </v-flex>
</template>

<script>
/* globals localStorage */

import GetActivityByUserQuery from '../queries/GetActivityByUserQuery'
import ListActivitiesByUserQuery from '../queries/ListActivitiesByUserQuery'
import AppConst from '../AppConst.js'
import MIDIUtils from 'midiutils'
import { roundDate } from '../date-utils.js'

function getLocaleDate (timestamp) {
  const halfDay = 12 * 60 * 60 * 1000
  return new Date(timestamp + halfDay).toLocaleDateString('en-us')
}

var todayStringDate = new Date()
var todayString = formatDateToString(todayStringDate)

function filterForActivities (items) {
  return items.filter(item => item.activityType !== 'NapTaken')
    .filter(item => item.activityType !== 'WaterConsumption')
    .filter(item => item.activityType !== 'VoiceCeilingPitch')
    .filter(item => item.activityType !== 'VoiceFeeling')
    .filter(item => item.activityType !== 'HelpAdminText')
    .filter(item => item.activityType !== 'Sick')
}
function filterForNaps (items) {
  return items.filter(item => item.activityType === 'NapTaken')
}
function filterForSick (items) {
  return items.filter(item => item.activityType === 'Sick')
}
function filterForWater (items) {
  return items.filter(item => item.activityType === 'WaterConsumption')
}
function filterForPitch (items) {
  return items.filter(item => item.activityType === 'VoiceCeilingPitch')
}
function filterForVoiceFeeling (items) {
  return items.filter(item => item.activityType === 'VoiceFeeling')
}
function filterForDate (items, daysAgo) {
  if (daysAgo === 3600) { return items }
  var today = new Date()
  var offset = new Date().setDate(today.getDate() - daysAgo)
  return items.filter(item => item.timestamp > offset)
}
function formatDateToString (date) {
  var dd = (date.getDate() < 10 ? '0' : '') + date.getDate()
  var MM = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1)
  var yyyy = date.getFullYear()

  // create the format you want
  return (yyyy + '-' + MM + '-' + dd)
}

function totalCombineValues (data) {
  var newList = []
  data.forEach(
    function (el) {
      var total = 0
      data.filter(item => item.activityType === el.activityType)
        .forEach(function (el2) {
          total += parseInt(el2.value)
        })
      var cpe = Object.assign({}, el)
      cpe.value = total
      newList.push(cpe)
    }
  )

  var duplicates = []
  return newList.filter(function (el) {
    if (duplicates.includes(el.activityType)) {
      return false
    } else {
      duplicates.push(el.activityType)
      return true
    }
  })
}

function totalGrandValues (data) {
  let grandTotal = {}
  let date
  let vpTotal = 0
  data.forEach(function (el2) {
    date = getLocaleDate(parseInt(el2.actDate))
    vpTotal += parseInt(el2.value)
  })
  grandTotal[date] = vpTotal
  return grandTotal
}

function getActivities (that, callback) {
  var ts = new Date(that.date)
  var tString = ts.getFullYear() + '-' + (ts.getMonth() + 1) + '-' + (ts.getDate() + 1)
  var selectedDateTime = roundDate(new Date(tString).getTime())
  selectedDateTime = roundDate(new Date(ts.getFullYear(), (ts.getMonth()), (ts.getDate() + 1), 0, 0, 0, 0).getTime())

  that.$apollo.query({
    variables: {
      actDate: selectedDateTime,
      username: localStorage.subID
    },
    query: GetActivityByUserQuery })
    .then(function (data) {
      var temp = []
      if (that.postType === 'Naps') {
        temp = filterForNaps(data.data.getActivityByUser.items)
      } else if (that.postType === 'Water') {
        temp = filterForWater(data.data.getActivityByUser.items)
      } else if (that.postType === 'Pitch') {
        temp = filterForPitch(data.data.getActivityByUser.items)
      } else { temp = filterForActivities(data.data.getActivityByUser.items) }
      callback(temp)
    }).catch(console.error)
}

function listActivities (that, callback) {
  that.$apollo.query({
    variables: {
      username: localStorage.subID
    },
    query: ListActivitiesByUserQuery })
    .then(function logData (data) {
      callback(data.data.listActivitiesByUser.items)
    }).catch(console.error)
}

function getDailyActAll (that) {
  getActivities(that, function (data) {
    var filtered = filterForActivities(data)
    that.items2 = totalCombineValues(filtered)
    // this fetches activities for the chart
  })
}

function getChartAll (that) {
  getActivities(that, function (data) {
    var newChart = []
    var dataVF = filterForVoiceFeeling(data)
    dataVF = filterForDate(dataVF, that.daysAgo)
    data = filterForActivities(data)
    var data2 = data
    var totalActValue = totalGrandValues(data2)

    data.forEach(
      function (el) {
        var tp = Object.values(data.filter(item => item.activityType === el.activityType))
        var activityData = {}
        tp.forEach(function (el2) {
          let date = getLocaleDate(parseInt(el2.actDate))
          if (activityData[date]) { activityData[date] = parseInt(activityData[date]) + parseInt(el2.value) } else {
            activityData[date] = el2.value
          }
        })
        // that.chartData.push({'name': el.activityType, 'data': activityData});
        newChart.push({ 'name': el.activityType, 'data': activityData })
      }
    )

    // push activityTotal for the day
    if (totalActValue > 0) {
      newChart.push({ 'name': 'Total Vocal Pts', 'data': totalActValue })
    }

    // push allotmentToal for the day
    // newChart.push({'name': 'Daily Allotment', 'data': dataVF});
    dataVF.forEach(
      function (el) {
        var date = getLocaleDate(parseInt(el.actDate))
        if (el.value > 0) {
          newChart.push({ 'name': 'Daily Allotment', 'data': { [date]: el.value } })
        }
      }
    )

    // remove duplicates from the object
    var duplicates = []
    that.chartData = newChart.filter(function (elem) {
      if (duplicates.includes(elem.name)) { return false } else {
        duplicates.push(elem.name)
        return true
      }
    })
  })

  listActivities(that, function (data) {
    let newChart = []
    data = filterForActivities(data)
    data = filterForDate(data, that.daysAgo)
    data.forEach(
      function (el) {
        let values = Object.values(data.filter(item => item.activityType === el.activityType))
        // combine values
        let tmpm = {}
        values.forEach(function (el2) {
          let tmpdm = getLocaleDate(parseInt(el2.actDate))
          if (tmpm[tmpdm]) { tmpm[tmpdm] = parseInt(tmpm[tmpdm]) + parseInt(el2.value) } else {
            tmpm[tmpdm] = el2.value
          }
        })
        // that.chartData.push({'name': el.activityType, 'data': tmpm});
        newChart.push({ 'name': el.activityType, 'data': tmpm })
      }
    )

    // remove duplicates from the object
    let duplicates = []
    that.chartData2 = newChart.filter(function (elem) {
      if (duplicates.includes(elem.name)) { return false } else {
        duplicates.push(elem.name)
        return true
      }
    })
  })
}

function getChartNaps (that) {
  listActivities(that, function (data) {
    var newChart = []
    data = filterForNaps(data)
    data = filterForDate(data, that.daysAgo)
    data.forEach(
      function (el) {
        var filtered = Object.values(data.filter(item => item.activityType === el.activityType))
        var dayData = {}
        filtered.forEach(function (el2) {
          var date = getLocaleDate(parseInt(el2.actDate))
          if (dayData[date]) { dayData[date] = parseInt(dayData[date]) + parseInt(el2.value) } else {
            dayData[date] = el2.value
          }
        })
        // that.chartData.push({'name': el.activityType, 'data': dayData});
        newChart.push({ 'name': 'Vocal Naps Taken', 'data': dayData })
      }
    )

    // remove duplicates from the object
    var duplicates = []
    that.chartDataNaps = newChart.filter(function (el) {
      if (duplicates.includes(el.name)) { return false } else {
        duplicates.push(el.name)
        return true
      }
    })
  })
}

function getChartSick (that) {
  listActivities(that, function (data) {
    var newChart = []
    data = filterForSick(data)
    data = filterForDate(data, that.daysAgo)
    data.forEach(
      function (el) {
        var filtered = Object.values(data.filter(item => item.activityType === el.activityType))
        var dayData = {}
        filtered.forEach(function (el2) {
          var date = getLocaleDate(parseInt(el2.actDate))
          if (dayData[date]) { dayData[date] = 1 } else {
            dayData[date] = 1
          }
        })
        // that.chartData.push({'name': el.activityType, 'data': dayData});
        newChart.push({ 'name': 'Day Marked as Sick', 'data': dayData })
      }
    )

    // remove duplicates from the object
    var duplicates = []
    that.chartDataSick = newChart.filter(function (elem) {
      if (duplicates.includes(elem.name)) { return false } else {
        duplicates.push(elem.name)
        return true
      }
    })
  })
}

function getChartWater (that) {
  listActivities(that, function (data) {
    var newChart = []
    data = filterForWater(data)
    data = filterForDate(data, that.daysAgo)
    data.forEach(
      function (el) {
        var filtered = Object.values(data.filter(item => item.activityType === el.activityType))
        var dayData = {}
        filtered.forEach(function (el2) {
          var date = getLocaleDate(parseInt(el2.actDate))
          if (dayData[date]) { dayData[date] = parseInt(dayData[date]) + parseInt(el2.value) } else {
            dayData[date] = el2.value
          }
        })
        // that.chartData.push({'name': el.activityType, 'data': dayData});
        newChart.push({ 'name': 'Water Consumption (oz)', 'data': dayData })
      }
    )

    // remove duplicates from the object

    var duplicates = []
    var ch = []
    ch = newChart.filter(function (elem) {
      if (duplicates.includes(elem.name)) { return false } else {
        duplicates.push(elem.name)
        return true
      }
    })

    that.chartDataWater = ch
  })
}

function getChartPitch (that) {
  listActivities(that, function (data) {
    var newChart = [{ name: 'Ceiling Pitch', data: {} }]
    data = filterForPitch(data)
    data = filterForDate(data, that.daysAgo)
    data.forEach(function (el2) {
      var date = getLocaleDate(parseInt(el2.actDate))
      newChart[0].data[date] = el2.value
    })
    that.chartDataPitch = newChart
  })
}

function getChartVoiceFeeling (that) {
  listActivities(that, function (data) {
    var newChart = []
    var newChart2 = []
    data = filterForVoiceFeeling(data)
    data = filterForDate(data, that.daysAgo)
    data.forEach(
      function (el) {
        var tp = Object.values(data.filter(item => item.activityType === el.activityType))
        var tmpm = {}
        var tmpm2 = {}
        tp.forEach(function (el2) {
          var tmpdm = getLocaleDate(parseInt(el2.actDate))
          tmpm[tmpdm] = AppConst.voiceFeelDefaults.find(feel => feel.text === el2.intensity).index - 1
          tmpm2[tmpdm] = el2.value
        })
        // that.chartData.push({'name': el.activityType, 'data': tmpm});
        newChart.push({ 'name': 'Voice Function', 'data': tmpm })
        newChart2.push({ 'name': 'Units Budgeted', 'data': tmpm2 })
      }
    )

    // remove duplicates from the object

    var duplicates = []
    var ch = newChart.filter(function (elem) {
      if (duplicates.includes(elem.name)) { return false } else {
        duplicates.push(elem.name)
        return true
      }
    })

    duplicates = []
    var ch2 = newChart2.filter(function (elem) {
      if (duplicates.includes(elem.name)) { return false } else {
        duplicates.push(elem.name)
        return true
      }
    })

    that.chartDataVoiceFeeling = ch
    that.chartDataUnitsBudgeted = ch2
  })
}

function getChartUnitsUsed (that) {
  listActivities(that, function (data) {
    var newChart = []
    var napData = filterForNaps(data)
    napData = filterForDate(napData, that.daysAgo)
    data = filterForActivities(data)
    data = filterForDate(data, that.daysAgo)
    var tmpmVP = {}
    var tmpdmVP = {}
    data.forEach(function (el) {
      var tmpVPtotal = 0
      var tp = Object.values(data.filter(item => item.actDate === el.actDate))
      tmpdmVP = getLocaleDate(parseInt(tp[0].actDate))
      tp.forEach(function (el2) {
        tmpVPtotal = parseInt(tmpVPtotal) + parseInt(el2.value)
      })
      tmpmVP[tmpdmVP] = tmpVPtotal
    })

    napData.forEach(function (el) {
      tmpdmVP = getLocaleDate(parseInt(el.actDate))
      var voiceFeel = that.chartDataVoiceFeeling[0].data[tmpdmVP]
      var napValue = AppConst.voiceFeelDefaults[voiceFeel].napValue
      if (isNaN(napValue)) {
        napValue = 1
      }
      tmpmVP[tmpdmVP] -= napValue
    })
    newChart.push({ 'name': 'Total Voice Points Units', 'data': tmpmVP })

    // remove duplicates from the object
    var duplicates = []
    var ch = []
    ch = newChart.filter(function (elem) {
      if (duplicates.includes(elem.dated)) { return false } else {
        duplicates.push(elem.dated)
        return true
      }
    })
    var test = {}
    test = ch
    that.chartDataUnitsUsed = test
    that.chartDataUnitsVsVoiceFeeling = []
    that.chartDataUnitsVsVoiceFeeling.push({ 'name': 'Total Voice Units Budgeted', 'data': that.chartDataUnitsBudgeted[0].data })
    that.chartDataUnitsVsVoiceFeeling.push({ 'name': 'Total Voice Units Used', 'data': that.chartDataUnitsUsed[0].data })
  })
}

export default {
  data () {
    return {
      title: '',
      date: todayString,
      GetActivityByUserQuery: GetActivityByUserQuery,
      ListActivitiesByUserQuery: ListActivitiesByUserQuery,
      headers: [
        { text: 'Activity', align: 'left', value: 'activityType' },
        // { text: 'Intensity', align: '', value: 'intensity' },
        { text: 'Daily Total', align: '', value: 'value' }
      ],
      voiceFeelDefaults: AppConst.voiceFeelDefaults,
      noteNumberToName: MIDIUtils.noteNumberToName,
      items2: [],
      pagination: { 'sortBy': 'value', 'descending': true, 'rowsPerPage': -1 },
      date2: null,
      daysAgo: 30,
      menu: false,
      modal: false,
      menu2: false,
      midiC2: 36,
      midiC7: 96,
      chartData: [],
      chartData2: [],
      chartDataNaps: [],
      chartDataSick: [],
      chartDataWater: [],
      chartDataPitch: [],
      chartDataVoiceFeeling: [],
      chartDataUnitsBudgeted: [],
      chartDataUnitsUsed: [],
      chartDataUnitsVsVoiceFeeling: [],
      allActivitiesChart: null,
      appTitle: AppConst.appTitle,
      active: 0,
      chartopt: {
        responsive: false,
        maintainAspectRatio: false,
        elements: {
          point: { radius: 0 }
        },
        scales: { xAxes: [{ ticks: {
          autoSkip: true,
          maxTicksLimit: 26
        } }] }
      },
      hpOpts: { series: { dataLabels: {
        enabled: true,
        formatter: function () {
          if (this.y > 0) { return this.point.label }
        }
      } } }
    }
  },
  components: {
    // 'voice-date-select': DateSelect,
  },
  methods: {
    onUpdate (items2, callback) {
      getActivities(this, function (data) {
        items2 = filterForActivities(data)
        callback(items2)
      })
    },
    logDate () {
      var that = this
      getActivities(this, function (data) {
        var ch = totalCombineValues(filterForActivities(data))
        that.items2 = ch
      })
      getChartAll(this)
      getChartVoiceFeeling(this)
      getChartUnitsUsed(this)
      getChartWater(this)
      getChartNaps(this)
      getChartPitch(this)
    }

  },
  created () {

  },
  mounted (that = this) {
    // this fetches activities for the list
    getDailyActAll(that)
    getChartAll(that)
    getChartVoiceFeeling(that)
    getChartUnitsUsed(that)
    getChartWater(that)
    getChartNaps(that)
    getChartPitch(that)
    getChartSick(that)
    window.x = this
  },
  updated () {

  },
  props: [
    'postTitle',
    'postFeelings',
    'postType'
  ]

}

// window chart instances id scales x-axis-0 options ticks autoSkip has chart objects
</script>


// WEBPACK FOOTER //
// src/components/stats/DataTableStats.vue